import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { denormalisedResponseEntities } from '../../util/data';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { listingImage } from '../../config/configLayout';

const PER_PAGE = 24;
const { aspectRatio: aspectRatioRaw, variantPrefix = 'listing-card' } = listingImage;
const aspectRatio = 1 / eval(aspectRatioRaw);
const defaultListQueryParams = {
  perPage: PER_PAGE,
  include: ['images', 'currentStock'],
  'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
  ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
  ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
  'limit.images': 1,
};

export const FavouriteListingsApi = createApi({
  reducerPath: 'FavouriteListingsApi',
  tagTypes: ['FavouriteListings'],
  baseQuery: fakeBaseQuery(),
  endpoints: builder => ({
    listFavouriteListings: builder.query({
      queryFn: async (arg, queryApi) => {
        const { extra: sdk } = queryApi;
        const { page = 1, ids = '' } = arg;
        if (!ids) {
          return { data: { listings: [], pagination: { totalItems: 0, totalPages: 0, page: 1 } } };
        }
        const params = { ids, page, ...defaultListQueryParams };
        const response = await sdk.listings.query(params);
        const listings = denormalisedResponseEntities(response);
        const pagination = response.data.meta;
        return { data: { listings, pagination } };
      },
      providesTags: ['FavouriteListings'],
    }),
  }),
});

export const { useListFavouriteListingsQuery } = FavouriteListingsApi;
